import React from 'react';
import { CheckIcon } from 'lucide-react';
import { summaryRows } from '../data/summary';
import { price, productName, totalBonuses, totalVolumes } from '../data/offer';
export function SummaryTable() {
  return <section className="bg-stage-deep tech-grid py-16 sm:py-20" aria-labelledby="summary-title" data-id="element-220" data-mp="o7b968omkoeg">
      <div className="mx-auto max-w-4xl px-4" data-id="element-221" data-mp="j882ykwwsc4w">
        <h2 id="summary-title" className="text-center text-3xl font-extrabold text-white sm:text-4xl" data-id="element-222" data-mp="j5c50wl29ngg">
          Everything included
        </h2>
        <p className="mt-3 text-center text-silver" data-id="element-223" data-mp="1bwvv90g2s1ry">
          {productName} · {totalVolumes} volumes + {totalBonuses} bonuses ·{' '}
          <b className="text-silverBright" data-id="element-224" data-mp="16uy6jqowoerm">{price}</b>
        </p>

        <ul className="mt-10 grid gap-3 sm:grid-cols-2" data-id="element-225" data-mp="12u4hgtzq8tx5">
          {summaryRows.map(([feature, detail]) => <li key={feature} className="flex gap-3 rounded-lg border border-silverEdge bg-navy p-4" data-id="element-226" data-mp="3rnrt3b2a9efq">
              <span className="metal-surface mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full" data-id="element-227" data-mp="3njttz0cyk3mo">
                <CheckIcon className="h-3.5 w-3.5 text-navyDeep" aria-hidden="true" data-id="element-228" data-mp="3idphtjvdw5y2" />
              </span>
              <p data-id="element-229" data-mp="3n9wl14web3cb">
                <b className="block text-sm text-silverBright" data-id="element-230" data-mp="39c81c0e2e28u">{feature}</b>
                <span className="text-sm text-silver" data-id="element-231" data-mp="39eaqyjbb1td1">{detail}</span>
              </p>
            </li>)}
        </ul>

        <blockquote className="mx-auto mt-10 max-w-2xl rounded-xl border-l-4 border-silver bg-navy px-6 py-5 text-center text-lg font-bold leading-relaxed text-silverBright" data-id="element-232" data-mp="2zmoi2tmfw6dg">
          “The best time to have these materials was at the start of your year. The second-best time is today.”
        </blockquote>
      </div>
    </section>;
}